/*eslint no-unused-vars: ["error", { "args": "none" }]*/

import {
  SEND_MESSAGE
} from "../types";
import { api } from "../../utils";

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    [SEND_MESSAGE]: ({ dispatch, commit }, payload) => {
      api("/send-message", "POST", payload.data).then(res => {
        return res;
      });
    },
  }
}